import React, { useCallback } from 'react';
import { createRoot } from 'react-dom/client';
import type { EmbeddedReportPayload } from '@aha-app/aha-editor-v2';
import EditPanelModal from './EditPanelModal';
import ReportProvider from './ReportProvider';

interface ConfigureReportModalComponentProps {
  payload: EmbeddedReportPayload;
  onReportUpdated: (payload: EmbeddedReportPayload) => void;
  onClose: () => void;
}

const ConfigureReportModal: React.FC<ConfigureReportModalComponentProps> = ({
  payload,
  onReportUpdated,
  onClose,
}) => {
  const updatePanel = useCallback(
    (id: RecordId, payload: any) => {
      onReportUpdated(payload);
    },
    [onReportUpdated]
  );

  return (
    <ReportProvider>
      <EditPanelModal
        open
        panel={payload}
        closePanelModal={onClose}
        updatePanel={updatePanel}
      />
    </ReportProvider>
  );
};

export async function configureReport(
  payload: EmbeddedReportPayload
): Promise<EmbeddedReportPayload | null> {
  const modalWindowEl = document.getElementById('modal-window');
  if (!modalWindowEl) throw new Error('No modal window element found');

  const root = createRoot(modalWindowEl);

  return new Promise<EmbeddedReportPayload | null>((resolve, reject) => {
    root.render(
      <ConfigureReportModal
        payload={payload}
        onReportUpdated={payload => {
          root.unmount();
          resolve(payload);
        }}
        onClose={() => {
          root.unmount();
          resolve(null);
        }}
      />
    );
  });
}

export default ConfigureReportModal;
